import ApiService from './apiService';

/**
 * OTP Service for handling OTP-related API calls
 */
class OTPService {
  /**
   * Resend OTP code to user's email
   * @param {string} email - User's email address
   * @returns {Promise<Object>} - API response
   */
  async resendOTP(email, purpose = 'email_verification') {
    try {
      const response = await ApiService.fetch('/auth/otp/resend', {
        method: 'POST',
        body: JSON.stringify({ email, purpose })
      });
      return await ApiService.handleResponse(response);
    } catch (error) {
      console.error('Resend OTP failed:', error);
      throw new Error(error.message || 'Failed to resend OTP');
    }
  }

  /**
   * Verify OTP code
   * @param {string} email - User's email address
   * @param {string} otp - 6-digit OTP code
   * @returns {Promise<Object>} - API response
   */
  async verifyOTP(email, otp) {
    try {
      const response = await ApiService.post('/auth/verify-otp', {
        email: email,
        otp: otp
      });
      return response.data;
    } catch (error) {
      console.error('OTP verification failed:', error);
      throw new Error(error.response?.data?.message || 'Invalid OTP code');
    }
  }

  /**
   * Check OTP status and remaining attempts
   * @param {string} email - User's email address
   * @returns {Promise<Object>} - API response with status info
   */
  async getOTPStatus(email) {
    try {
      const response = await ApiService.get(`/auth/otp-status/${encodeURIComponent(email)}`);
      return response.data;
    } catch (error) {
      console.error('Get OTP status failed:', error);
      throw new Error(error.response?.data?.message || 'Failed to get OTP status');
    }
  }
}

export default new OTPService();
